export const SAVE_ROUTE_ITEM = "SAVE_ROUTE_ITEM"
export const SAVE_ROUTE_ITEMS = "SAVE_ROUTE_ITEMS"
export const add_route_item = "add_route_item"
export const SAVE_JOBS = "SAVE_JOBS"
export const SAVE_ABNORMALITIES = "SAVE_ABNORMALITIES"
export const SAVE_SERVICE_TYPES = "SAVE_SERVICE_TYPES"
export const SAVE_PROVIDERS = "SAVE_PROVIDERS"
export const CREATE_ROUTE_ITEM = "CREATE_ROUTE_ITEM"
export const UPDATE_ROUTE_ITEM = "UPDATE_ROUTE_ITEM"
export const finished_route_item = "finished_route_item"
export const save_reason_for_not_signing = "save_reason_for_not_signing"
